import CRC32 from "crc-32";

// crc-32 returns signed int32; the DFU protocol uses unsigned. Mask to >>>0.
export function crc32(bytes: Uint8Array, seed?: number): number {
  const signed = CRC32.buf(bytes, seed);
  return signed >>> 0;
}
